import React, { useState } from "react";
export default function CommanCardDeatils({ detailList = [] }) {
  const [hovered, setHovered] = useState(null);

  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    // padding: "10px",
  };

  const cardBase = {
    background: "linear-gradient(135deg, #ffffff, #f1f3f6)",
    borderRadius: "12px",
    padding: "8px 12px",
    minWidth: "120px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
    transition: "all 0.25s ease",
    cursor: "pointer",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  };

  return (
    <div style={containerStyle}>
      {detailList.map((stat, index) => (
        <div
          key={index}
          onMouseEnter={() => setHovered(index)}
          onMouseLeave={() => setHovered(null)}
          style={{
            ...cardBase,
            transform: hovered === index ? "translateY(-3px)" : "none",
            boxShadow:
              hovered === index
                ? "0 6px 15px rgba(0,0,0,0.15)"
                : "0 3px 10px rgba(0,0,0,0.08)",
            borderLeft: `4px solid ${stat.color || "#2196f3"}`,
          }}
        >
          {/* Label */}
          <div
            style={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#444",
            }}
          >
            {stat.label}:
          </div>

          {/* Value */}
          <div
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: stat.color || "#2196f3",
            }}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
}

/*
✅ Flex layout (text + value side-by-side)
✅ Compact small cards
✅ Border color indicator
✅ Hover lift effect
✅ Pure React + CSS only

Perfect for dashboard stat ribbons / summary rows
*/
